// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__t405d","colMaxWidth":"Table_colMaxWidth__2m7Bx"};